module.exports = {"previous":"&laquo; Vorherige Seite","next":"Nächste Seite &raquo;"};